import BaseModelAPI from '../BaseModelAPI';

export default class WorkOrderProcessList extends BaseModelAPI {

	static entity = 'workorderprocesslist'
	static entityName = 'workorderprocess';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
